import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

import { Messages } from '~src/codegen/Localize';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { AddServiceAccountCredentialRequest, IAddServiceAccountCredentialResult} from '~src/ts/ServerApi/requests/AddServiceAccountCredentialRequest';

import { AuthModeState } from '../components/AddCredentialAuthModeDialog';

const MAX_SERVICE_ACCOUNT_FILE_SIZE_BYTES = 5242880;

export namespace AddServiceAccountFileAction {
    export function addServiceAccountFile(file: File, updateDialogState: React.Dispatch<MergeOrUpdateStateAction<AuthModeState>>): Promise<IAddServiceAccountCredentialResult> {
        // Send the file contents and the file name to the webClient api.
        // We could do this step with a FileUpload -> use file on the webclient side
        // but after talking with people familiar with this code, this is easier as
        // the service account files are only used for the purpose of parsing the contents.
        // We have no need to store the files, and then are quite small in size, and in json.
        // Therefore, we just parse the contents to send along. 
        return new Promise((resolve, reject) => {
            if (file.size > MAX_SERVICE_ACCOUNT_FILE_SIZE_BYTES){
                updateDialogState({ errorMessage: Messages.addNewSavedCredentialServiceAccountExceedMaxFileSize() });
                return reject();
            }
            const reader = new FileReader();
            let contents: string;
            reader.onerror = () => reject(new Error(Messages.addNewSavedCredentialServiceAccountInvalidFile()));
            reader.onload = () => {
                // Get the results from the file read, but strip out the data:*/*;base64.
                contents = reader.result
                    .toString()
                    .replace('data:', '')
                    .replace(/^.+,/, '');

                // Make sure we pass in a valid json.
                try {
                    JSON.parse(atob(contents));
                }
                catch(e) {
                   updateDialogState({ errorMessage: Messages.addNewSavedCredentialServiceAccountInvalidFile_InvalidJSON() });
                   return reject();
                }

                let request = new AddServiceAccountCredentialRequest({text: contents});
                return WebHttpClient.sendRequest(request).then((result: IAddServiceAccountCredentialResult) => {
                    if (result.errors) {
                        updateDialogState({ errorMessage: Messages.addNewSavedCredentialServiceAccountInvalidFile() });
                        return reject(result.errors);
                    } else {
                        return resolve(result);
                    }
                });
            };
            // Reads in the file contents as a dataUrl base64 encoded string.
            // example: data:application/json;base64<filecontents>
            reader.readAsDataURL(file);
        });
    }
}